import { addDoc, collection, getFirestore } from "firebase/firestore";
import React, { createRef, useState } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Col,
  Row,
  Radio,
  DatePicker,
  Select,
} from "antd";
import "antd/dist/antd.css";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useCartContext } from "../../context/CartContext";
import ItemCart from "../ItemCart";
import "moment/locale/es";
import locale from "antd/es/date-picker/locale/es_ES";

const { Item } = Form;
const { Password } = Input;
const { Group } = Radio;
const { Option } = Select;

const AddItem = () => {
  //var VN1 = this.name.substring(this.name.lastIndexOf("_")+1);
  var VN1 = "pr1";

  var objLocal1 = {};
  objLocal1.pw1   = 0;

  if(objLocal1.pw1===0){objLocal1.pw1=1} else {objLocal1.pw1=0};


  const { cart, totalPrice } = useCartContext();

  const [value, setValue] = useState(1);

  const formRef = createRef();

  const formSuccess = (datos) => {
    //console.log("Formulario enviado exitosamente: ", datos.);
    addFirebase(datos);
    console.log("Formulario enviado exitosamente: ", datos);
  };

  const formFailed = (error) => {
    console.log("Error: ", error);
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const prefixSelector = (
    <Item name="selectCodigo" noStyle>
      <Select style={{ width: 80 }} defaultValue="52">
        <Option> value="52">+52</Option>
        <Option> value="53">+53</Option>
        <Option> value="54">+54</Option>
        <Option> value="55">+55</Option>
        <Option> value="56">+56</Option>
      </Select>
    </Item>
  );

  const borrarCampos = () => {
    formRef.current.resetFields();
  };

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 4,
      },
      sm: {
        span: 20,
      },
    },
  };

  const order = {
    buyer: {
      name: "pablo",
      email: "pablo@gmail.com",
      phone: "12345",
      address: "asdd",
    },
    items: cart.map((product) => ({
      id: product.id,
      title: product.title,
      price: product.price,
      quantity: product.quantity,
    })),
    total: totalPrice(),
  };

  const boton1 = () => {
    console.log("boton1");
	  document.dispatchEvent(new CustomEvent(VN1, {detail: {name: VN1, values: JSON.stringify(objLocal1) }  }));
    // const db = getFirestore();
    // const ordersCollection = collection(db, "orders");
    // addDoc(ordersCollection, order).then(({ id }) => console.log(id));
  };

  

  const evento1 = () => {
    console.log("evento1 addItem 119");
    //document.dispatchEvent(new CustomEvent(VN1, {detail: {name: VN1, values: JSON.stringify(objLocal1) }  }));
    // const db = getFirestore();
    // const ordersCollection = collection(db, "orders");
    // addDoc(ordersCollection, order).then(({ id }) => console.log(id));
  };

document.addEventListener(VN1, evento1, true);


  const handleClickAdd = () => {
    const db = getFirestore();
    const ordersCollection = collection(db, "orders");
    addDoc(ordersCollection, order).then(({ id }) => console.log(id));
  };

  const addFirebase = (datos) => {
    const db = getFirestore();
    const ordersCollection = collection(db, "products");
    addDoc(ordersCollection, datos).then(({ id }) => console.log(id));
  };

  return (
    <div>
      <Row>
        <Col xs={1} sm={2} md={6} lg={7}>
          {" "}
        </Col>

        <Col xs={22} sm={20} md={12} lg={10}>
          <Form
            name="formulario"
            initialValues={{
              recordar: true,
            }}
            onFinish={formSuccess}
            onFinishFailed={formFailed}
            ref={formRef}
            {...formItemLayout}
          >
                    <br /> <br />
            <Item
              label="Categoria"
              name="category"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa la categoria",
                },
              ]}
            >
              <Input />
            </Item>

            <Item
              label="Titulo"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa el titulo",
                },
              ]}
            >
              <Input />
            </Item>

            <Item
              label="Precio"
              name="price"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa el precio",
                },
              ]}
            >
              <Input />
            </Item>

            <Item
              label="Imagen"
              name="image"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa la imagen",
                },
              ]}
            >
              <Input />
            </Item>

            {/* <Item label="Direccion" name="direccion">
              <Input />
            </Item> */}

            {/* <Item
              label="Sexo"
              name="sexo"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa tu Sexo",
                },
              ]}
            >
              <Group
                onChange={onChange}
                value={value}
                name="radioButton"
                defaultValue={1}
              >
                <Radio value={1}>Hombre</Radio>
                <Radio value={2}>Mujer</Radio>
              </Group>
            </Item> */}

            {/* <Item label="Fecha de Nacimiento" name="fechaNacimiento">
              <DatePicker style={{ width: "100%" }} locale={locale} />
            </Item> */}

            {/* <Item label="Numero Telefonico" name="numeroTelefonico">
              <Input
                addonBefore={prefixSelector}
                style={{ width: "100%" }}
                maxlength={10}
              />
            </Item> */}

            {/* <Item
              label="contraseña"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa tu contraseña",
                },
              ]}
            >
              <Password />
            </Item>

            <Item name="recordar" valuePropName="checked">
              <Checkbox>Recordar Usuario</Checkbox>
            </Item> */}

            <Item style={{ textAlign: "center" }}>
              {/* <Button type="primary" htmlType="submit">Iniciar sesion </Button> */}
              <br /> <br />
              <Button type="primary" htmlType="submit">
                Registrar usuario
              </Button>
              &nbsp;&nbsp;&nbsp;
              <Button htmlType="button" onClick={borrarCampos}>
                Borrar campos
              </Button>
            </Item>
          </Form>
        </Col>

        <Col xs={1} sm={2} md={6} lg={7}>
          {" "}
        </Col>
      </Row>
      <br /> <br />
      <button onClick={handleClickAdd}>Añadir Item nuevo</button>
      <br /> <br />
      <button onClick={boton1}>generar evento 1</button>
    </div>
  );
};

export default AddItem;
